import { render, staticRenderFns } from "./RcvExL.vue?vue&type=template&id=65708bb8"
import script from "./RcvExL.vue?vue&type=script&lang=js"
export * from "./RcvExL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports